// API Configuration
// Centralized configuration for all API calls

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.tyhjyys.com';

// Export the base URL and common endpoints
export const apiConfig = {
  baseUrl: API_BASE_URL,
  
  // Authentication endpoints
  auth: {
    verify: `${API_BASE_URL}/auth/verify`,
    google: `${API_BASE_URL}/auth/google`,
    logout: `${API_BASE_URL}/auth/logout`,
  },
  
  // Game endpoints
  games: {
    all: `${API_BASE_URL}/api/games`,
    withPredictions: `${API_BASE_URL}/api/games/with-predictions`,
    teams: `${API_BASE_URL}/api/games/teams/all`,
  },
  
  // User endpoints
  users: {
    profile: (userId) => `${API_BASE_URL}/api/users/${userId}`,
    stats: (userId) => `${API_BASE_URL}/api/users/${userId}/stats`,
    updateProfile: `${API_BASE_URL}/api/users/profile`,
    uploadAvatar: `${API_BASE_URL}/api/users/upload-avatar`,
  },
  
  // Prediction endpoints
  predictions: {
    create: `${API_BASE_URL}/api/predictions`,
    user: (userId) => `${API_BASE_URL}/api/predictions/user/${userId}`,
  },
  
  // Leaderboard endpoints
  leaderboard: {
    overall: `${API_BASE_URL}/api/leaderboard`,
    weekly: `${API_BASE_URL}/api/leaderboard/weekly`,
  },
  
  // Admin endpoints
  admin: {
    games: `${API_BASE_URL}/api/admin/games`,
    game: (gameId) => `${API_BASE_URL}/api/admin/games/${gameId}`,
    teams: `${API_BASE_URL}/api/admin/teams`,
    team: (teamId) => `${API_BASE_URL}/api/admin/teams/${teamId}`,
    users: `${API_BASE_URL}/api/admin/users`,
    userRole: (userId) => `${API_BASE_URL}/api/admin/users/${userId}/role`,
    recalculatePoints: `${API_BASE_URL}/api/admin/recalculate-points`,
  },
};

// Helper function to build URLs
export const buildApiUrl = (endpoint) => {

  return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};

export default API_BASE_URL;
